import { useNavigationEventBusStore as t } from "./navigation-event-bus-store.js";
function n() {
  return t();
}
export {
  n as useNavigationEventBus
};
//# sourceMappingURL=default-navigation-event-bus.js.map
